import { DashboardPeriodEcho, DashboardPeriodRequest, IsoDate } from './dashboard-filters.model';
import { DashboardVm } from './dashboard-vm.model';
import { PipelineCardVm, PipelineRatio } from './pipeline-health.model';

/** Wire value of the `period` query parameter; picks the preceding period the deltas compare with. */
export enum ConversionWirePeriod {
  MTD = 'mtd',
  QTD = 'qtd',
  YTD = 'ytd',
  CUSTOM = 'custom',
}

export interface ConversionMetricsRequest extends DashboardPeriodRequest {
  period: ConversionWirePeriod;
}

export interface ConversionRatio extends PipelineRatio {
  /** Percentage points against the preceding period; null when there is nothing to compare. */
  deltaPoints: number | null;
}

/** Ratios of the pipeline funnel's own ranks, in the design's order. */
export interface ConversionCards {
  submittedToApproved: ConversionRatio;
  approvedToFunded: ConversionRatio;
  startedToFunded: ConversionRatio;
}

/** The preceding window the deltas were taken against; `to` is exclusive. */
export interface ConversionComparison {
  period: ConversionWirePeriod;
  from: IsoDate;
  to: IsoDate;
  cutoffUtc: Date;
}

export interface ConversionMetrics {
  asOfUtc: Date;
  period: DashboardPeriodEcho;
  cards: ConversionCards;
  comparison: ConversionComparison | null;
}

export interface ConversionCardVm extends PipelineCardVm {
  /** Null renders nothing. */
  deltaLabel: string | null;
}

export interface ConversionMetricsDataVm {
  cards: ConversionCardVm[];
}

export type ConversionMetricsVm = DashboardVm<ConversionMetricsDataVm>;
